import React, { useMemo, memo } from "react";
import NextImage from "next/image";
import { getImgDimensions } from "utils/helpers";

const Image = memo(function Image(props) {
	const { fields, url: propUrl, extraClass, width, height, sectionIndex, maxWidth, maxHeight, alignImage: propAlignImage } = props;
	
	const imageData = useMemo(() => {
		if (!fields?.media?.fields?.file?.url && !propUrl) {
			return null;
		}

		let url = propUrl || fields?.media?.fields?.file?.url;
		url = url.startsWith("https") ? url : `https:${url}`;

		const allClasses = `${fields?.class ? fields?.class : " "} ${extraClass ? extraClass : " "}`;
		const imageBottomSpace = fields?.imageBottomSpace !== undefined ? fields?.imageBottomSpace : false;
		let imageWidth = width || fields?.imageWidth;
		let imageHeight = height || fields?.imageHeight;
		const alignImage = propAlignImage || fields?.alignImage || "center";

		const imageType = url.split(".").pop();
		let imageAIP = "";

		const originalWidth = fields?.media?.fields?.file?.details?.image?.width;
		const originalHeight = fields?.media?.fields?.file?.details?.image?.height;

		if (imageWidth && imageHeight) {
			imageAIP = `fit=scale&w=${Math.floor(imageWidth)}&h=${Math.floor(imageHeight)}&`;
		} else if (!imageWidth && !imageHeight) {
			imageWidth = originalWidth;
			imageHeight = originalHeight;
			if (imageWidth > 1500) {
				imageWidth = 1500;
				const { w, h } = getImgDimensions({ w: imageWidth, fields });
				imageHeight = h;
				imageAIP = `fit=scale&w=${w}&h=${h}&`;
			}
		} else if (imageWidth && !imageHeight) {
			const { w, h } = getImgDimensions({ w: imageWidth, fields });
			imageHeight = h;
			imageAIP = `fit=scale&w=${w}&h=${h}&`;
		} else if (imageHeight && !imageWidth) {
			const { w, h } = getImgDimensions({ h: imageHeight, fields });
			imageWidth = w;
			imageAIP = `fit=scale&w=${w}&h=${h}&`;
		}

		if (maxWidth && imageWidth > maxWidth) {
			imageWidth = maxWidth;
			const { w, h } = getImgDimensions({ w: imageWidth, fields });
			imageHeight = h;
			imageAIP = `fit=scale&w=${w}&h=${h}&`;
		}

		if (maxHeight && imageHeight > maxHeight) {
			imageHeight = maxHeight;
			const { w, h } = getImgDimensions({ h: imageHeight, fields });
			imageWidth = w;
			imageAIP = `fit=scale&w=${w}&h=${h}&`;
		}

		const isSvg = imageType.toLowerCase() === "svg";
		
		if (!imageWidth) imageWidth = originalWidth;
		if (!imageHeight) imageHeight = originalHeight;

		if (isSvg) {
			imageAIP = "";
		}

		const finalSrc = `${url}${imageAIP ? `?${imageAIP}` : ""}`;

		return {
			url,
			finalSrc,
			imageWidth,
			imageHeight,
			allClasses,
			imageBottomSpace,
			alignImage,
			isSvg,
			alt: fields?.media?.fields?.description || ""
		};
	}, [
		fields?.media?.fields?.file?.url,
		fields?.media?.fields?.file?.details?.image?.width,
		fields?.media?.fields?.file?.details?.image?.height,
		fields?.media?.fields?.description,
		fields?.class,
		fields?.imageWidth,
		fields?.imageHeight,
		fields?.alignImage,
		fields?.imageBottomSpace,
		propUrl,
		extraClass,
		width,
		height,
		maxWidth,
		maxHeight,
		propAlignImage
	]);

	if (!imageData) {
		return <></>;
	}

	return (
		<div
			key={imageData.url}
			style={{
				position: "relative",
				display: "flex",
				justifyContent: imageData.alignImage,
				...(imageData.imageBottomSpace && { marginBottom: imageData.imageBottomSpace + "em" }),
			}}
			className={imageData.allClasses}
		>
			<span>
				<NextImage
					priority={sectionIndex < 3}
					loading={sectionIndex < 3 ? "eager" : "lazy"}
					className={imageData.allClasses}
					width={imageData.imageWidth}
					height={imageData.imageHeight}
					src={imageData.finalSrc}
					alt={imageData.alt}
					style={{ width: "100%", height: "auto" }}
					placeholder="empty"
				/>
			</span>
		</div>
	);
});

export default Image;
